__turbopack_context__.v({
  "addToWallet": "TokenDetailPage-module__9nupia__addToWallet",
  "copyButton": "TokenDetailPage-module__9nupia__copyButton",
  "detailCard": "TokenDetailPage-module__9nupia__detailCard",
  "emptyIcon": "TokenDetailPage-module__9nupia__emptyIcon",
  "emptyState": "TokenDetailPage-module__9nupia__emptyState",
  "header": "TokenDetailPage-module__9nupia__header",
  "holderBar": "TokenDetailPage-module__9nupia__holderBar",
  "holderBarFill": "TokenDetailPage-module__9nupia__holderBarFill",
  "holderBarTrack": "TokenDetailPage-module__9nupia__holderBarTrack",
  "label": "TokenDetailPage-module__9nupia__label",
  "link": "TokenDetailPage-module__9nupia__link",
  "loading": "TokenDetailPage-module__9nupia__loading",
  "pageButton": "TokenDetailPage-module__9nupia__pageButton",
  "pageButtonActive": "TokenDetailPage-module__9nupia__pageButtonActive",
  "pagination": "TokenDetailPage-module__9nupia__pagination",
  "row": "TokenDetailPage-module__9nupia__row",
  "skeleton": "TokenDetailPage-module__9nupia__skeleton",
  "skeletonShimmer": "TokenDetailPage-module__9nupia__skeletonShimmer",
  "symbol": "TokenDetailPage-module__9nupia__symbol",
  "tab": "TokenDetailPage-module__9nupia__tab",
  "tabActive": "TokenDetailPage-module__9nupia__tabActive",
  "table": "TokenDetailPage-module__9nupia__table",
  "tableContainer": "TokenDetailPage-module__9nupia__tableContainer",
  "tabs": "TokenDetailPage-module__9nupia__tabs",
  "title": "TokenDetailPage-module__9nupia__title",
  "tokenIcon": "TokenDetailPage-module__9nupia__tokenIcon",
  "typeBadge": "TokenDetailPage-module__9nupia__typeBadge",
  "value": "TokenDetailPage-module__9nupia__value",
});
